import { MotionConfig } from "framer-motion";
import React from "react";
import "./App.css";
import CaseStudies from "./components/CaseStudies";
import Contact from "./components/Contact";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import SatisfiedCustomers from "./components/SatisfiedCustomers";
import TechStack from "./components/TechStack";
import Timeline from "./components/Timeline";
import { ContactProvider } from "./contexts/contactContext";
import { TimelineProvider } from "./contexts/TimelineContext";
import { DarkModeProvider } from "./hooks/useTheme";

const ContentContainer: React.FC<{ id: string; children: React.ReactNode }> = ({ id, children }) => (
  <div
    id={id}
    className="transition-colors duration-500 ease-in-out relative z-10 py-8"
  >
    {children}
  </div>
);

const App: React.FC = () => {
  return (
    <MotionConfig reducedMotion="user">
      <TimelineProvider>
      <DarkModeProvider>
        <ContactProvider>
          <div className="App">
            <Navbar />
            <div id="home" className="header-container relative">
              <Header />
            </div>
            <ContentContainer id="experience">
              <Timeline />
            </ContentContainer>
            <ContentContainer id="satisfied-customers">
              <SatisfiedCustomers />
            </ContentContainer>
            {/* <ContentContainer id="testimonials">
              <Testimonials />
            </ContentContainer> */}
            <ContentContainer id="case-studies">
              <CaseStudies />
            </ContentContainer>
            <ContentContainer id="tech-stack">
              <TechStack />
            </ContentContainer>
            <ContentContainer id="faq">
              <FAQ />
            </ContentContainer>
            <ContentContainer id="contact">
              <Contact />
            </ContentContainer>
            <Footer />
          </div>
        </ContactProvider>
      </DarkModeProvider>
      </TimelineProvider>
    </MotionConfig>
  );
};

export default App;
